var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCo2E(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CO2e",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.137,
    height: 10.137,
    viewBox: "0 0 10.137 10.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55495",
    "data-name": "Group 55495"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 1.048,
    cy: 1.048,
    r: 1.048,
    fill: "#66939e"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 0.689,
    cy: 0.689,
    r: 0.689,
    transform: "translate(5.768 4.264)",
    fill: "#66939e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86258",
    "data-name": "Path 86258",
    d: "M9.344,37.61a2.726,2.726,0,0,0-2.059-4.449,2.656,2.656,0,0,0-1.669.6,1.874,1.874,0,0,0-3.375,1.018H2.217A2.228,2.228,0,0,0,.4,38.271a2.261,2.261,0,0,0,.722.669,2.269,2.269,0,0,0-.148.807,2.218,2.218,0,0,0,2.2,2.232,2.182,2.182,0,0,0,1.727-.851,2.839,2.839,0,0,0,2.391,1.354A2.807,2.807,0,0,0,9.3,41.629a2.886,2.886,0,0,0,.045-4.019Zm-4.5.577A1.073,1.073,0,0,1,4,38.572a1.283,1.283,0,1,1,.718-2.347.3.3,0,1,1-.333.492A.689.689,0,1,0,4,37.978a.5.5,0,0,0,.344-.121.5.5,0,0,0,.05-.052.3.3,0,1,1,.455.382Zm.33-.887a1.283,1.283,0,1,1,1.283,1.283A1.285,1.285,0,0,1,5.174,37.3ZM8.24,40.7c-.225,0-.388,0-.509,0a1.162,1.162,0,0,1-.373-.022.307.307,0,0,1-.2-.2c-.048-.157.031-.26.13-.391.078-.1.222-.291.464-.637a.747.747,0,0,0,.115-.219l0-.017a.1.1,0,0,0-.191-.007A.3.3,0,0,1,7.1,39.1a.691.691,0,0,1,1.369.134.3.3,0,0,1,0,.038l-.008.06a.3.3,0,0,1-.005.029,1.271,1.271,0,0,1-.21.437c-.086.122-.16.226-.223.313l.212,0h0a.3.3,0,0,1,0,.594Z",
    transform: "translate(0 -32.347)",
    fill: "#66939e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2E);
export default __webpack_public_path__ + "static/media/co2e.6fc092d87fa5ceedf65aeecbe00494de.svg";
export { ForwardRef as ReactComponent };